<template>
  <div class="sidebar-logo-container" :class="{ collapse: collapse }">
    <router-link v-if="collapse" key="collapse" class="sidebar-logo-link" to="/">
      <img v-if="logo" :src="logo" class="sidebar-logo" />
    </router-link>
    <router-link v-else key="expand" class="sidebar-logo-link" to="/">
      <img v-if="logo" :src="logo" class="sidebar-logo" />
      <!-- <img src="@/assets/image/LOGONAME_1.png" class="sidebar-logoName" /> -->
      <img src="@/assets/image/LOGONAME.png" class="sidebar-logoName" />
    </router-link>
  </div>
</template>

<script>
import { getImgUrl } from '@/api/getFile'
export default {
  name: 'SidebarLogo',
  props: {
    collapse: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {}
  },
  computed: {
    logo() {
      return this.$store.getters.sealConfig.companyLogo ? getImgUrl(this.$store.getters.sealConfig.companyLogo) : require('@/assets/image/LOGO.png')
    },
    companyName() {
      return this.$store.getters.sealConfig.companyName
    },
  },
}
</script>

<style lang="scss" scoped>
.sidebarLogoFade-enter-active {
  transition: opacity 1.5s;
}

.sidebarLogoFade-enter,
.sidebarLogoFade-leave-to {
  opacity: 0;
}

.sidebar-logo-container {
  position: relative;
  width: 100%;
  height: 56px;
  line-height: 56px;
  background: rgb(24, 46, 68);
  text-align: center;
  overflow: hidden;

  & .sidebar-logo-link {
    height: 100%;
    width: 100%;
    text-align: start;
    padding: 0 15px;
    box-sizing: border-box;
    & .sidebar-logo {
      width: 25px;
      height: 24px;
      vertical-align: middle;
      margin-right: 10px;
    }
    & .sidebar-logoName {
      // width: 120px;
      // height: 24px;
      vertical-align: middle;
    }

    & .sidebar-title {
      display: inline-block;
      margin: 0;
      color: #fff;
      font-weight: 600;
      line-height: 50px;
      font-size: 14px;
      font-family: Avenir, Helvetica Neue, Arial, Helvetica, sans-serif;
      vertical-align: middle;
    }
  }

  &.collapse {
    .sidebar-logo {
      margin-right: 0px;
    }
  }
}
</style>
